import React from "react";
import { Drawer, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CheckoutDrawer = ({ open, onClose, children }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      // disableScrollLock={true} // ✅ Allow main site to scroll
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "420px" },
          padding: 2,
          overflow: "visible", // ✅ Prevent drawer from scrolling
          height: "100vh", // ✅ Full height to match viewport
        },
      }}
      sx={{
        zIndex: 1400, // ✅ Ensure drawer is always above AppBar + Free Shipping bar
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 30,
          top: 25,
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
      {children}
    </Drawer>
  );
};

export default CheckoutDrawer;
